/* eslint-disable */
import { React, useState, useContext, useEffect } from 'react';

import { styled } from '@mui/material/styles';
import { FormControl, InputLabel, Select, MenuItem, Button, CircularProgress, Skeleton, Chip } from '@mui/material';

// assets
import { Box } from '@mui/material';
import { Divider } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import ReactLoading from 'react-loading';
import { useNavigate } from 'react-router-dom';
import AppContext from '../../../components/AppContext';
import axios from 'axios';
import AlertBar from '../../../ui-component/AlertBar';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BusinessIcon from '@mui/icons-material/Business';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// styles
const IFrameWrapper = styled('iframe')(({ theme }) => ({
    height: 'calc(100vh - 210px)',
    border: '1px solid',
    borderColor: theme.palette.primary.light
}));

// =============================|| Landing  ||============================= //

const UnitSelection = () => {
    useEffect(() => {
        getUnits();
    }, []);

    const [Value, setValue] = useState('AMC');
    const myContext = useContext(AppContext);
    const navigate = useNavigate();
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
    const [unitData, setUnitData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [openmessageflag, setOpenMessageFlag] = useState(false);
    const [selectedUnit, setSelectedUnit] = useState(window.sessionStorage.getItem('unit-code') || '');
    const [errorMessage, setErrorMessage] = useState('Unable to load units. Please try again or contact administrator.');

    //Handle success/warning message close
    const handleMessageClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenMessageFlag(false);
    };

    async function getUnits() {
        try {
            const token = await getAccessTokenSilently();
            const response = await axios
                .get('api/units', {
                    headers: {
                        authorization: `Bearer ${token}`
                    }
                })
                .then((response) => {
                    // handle success
                    if (user.email.includes('@bpg.com')) {
                        var result = response.data.filter((item) => item.orgid === 'BAN');
                    } else if (user.email.includes('@amc.com')) {
                        var result = response.data.filter((item) => item.orgid === 'AMC');
                    } else {
                        var result = response.data;
                    }

                    setUnitData(result);
                    setIsLoading(false);

                    // Auto-select if only one unit available
                    if (result.length === 1) {
                        setSelectedUnit(result[0].id);
                        sessionStorage.setItem('unit-value', result[0].name);
                        sessionStorage.setItem('unit-code', result[0].id);
                        myContext.setUnitValue(result[0].name);
                        myContext.setUnitCode(result[0].id);
                    }
                })
                .catch((error) => {
                    // handle error
                    setIsLoading(false);
                    setErrorMessage(error.response?.data || 'Unable to load units. Please check your connection and try again.');
                    setOpenMessageFlag(true);
                });
        } catch (error) {
            setIsLoading(false);
            setErrorMessage('An unexpected error occurred. Please try refreshing the page.');
            setOpenMessageFlag(true);
        }
    }

    const handleClickSelectButton = () => {
        if (selectedUnit) {
            navigate('/landing');
        }
    };

    const handleChangeUnitValue = (e, x) => {
        const unitCode = e.target.value;
        const unitName = x.props.name;

        setSelectedUnit(unitCode);
        sessionStorage.setItem('unit-value', unitName);
        sessionStorage.setItem('unit-code', unitCode);

        myContext.setUnitValue(unitName);
        myContext.setUnitCode(unitCode);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && selectedUnit && !isLoading) {
            handleClickSelectButton();
        }
    };

    return (
        <div
            style={{ backgroundColor: '#e3f2fd', borderRadius: '25px', minHeight: 'calc(100vh - 110px)', margin: '10px', padding: '20px' }}
        >
            <Box
                variant="outlined"
                sx={{
                    boxShadow: 3,
                    p: { xs: 3, sm: 4 },
                    m: 'auto',
                    mt: 4,
                    borderRadius: '16px',
                    backgroundColor: 'white',
                    maxWidth: { xs: '100%', sm: '500px', md: '600px' },
                    width: '100%'
                }}
                minHeight="20vh"
                onKeyPress={handleKeyPress}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    <BusinessIcon color="primary" sx={{ fontSize: 32 }} />
                    <Typography variant="h4" component="div">
                        Select Unit
                    </Typography>
                </Box>

                {unitData.length > 0 && (
                    <Chip
                        label={`${unitData.length} unit${unitData.length > 1 ? 's' : ''} available`}
                        size="small"
                        color="primary"
                        variant="outlined"
                        sx={{ mb: 2 }}
                    />
                )}

                <Divider sx={{ mb: 3 }} />

                {isLoading ? (
                    <Box sx={{ mb: 3 }}>
                        <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1, mb: 2 }} />
                        <Skeleton variant="rectangular" height={36} width={120} sx={{ borderRadius: 1, mx: 'auto' }} />
                    </Box>
                ) : (
                    <>
                        <FormControl fullWidth style={{ backgroundColor: 'white', marginBottom: '16px' }}>
                            <InputLabel id="unit-select-label">Unit</InputLabel>
                            <Select
                                labelId="unit-select-label"
                                id="unit-select"
                                label="Unit"
                                value={selectedUnit}
                                onChange={handleChangeUnitValue}
                                disabled={unitData.length === 0}
                                startAdornment={selectedUnit && <CheckCircleOutlineIcon color="success" sx={{ ml: 1, mr: 1 }} />}
                            >
                                {unitData.length === 0 ? (
                                    <MenuItem disabled>No units available</MenuItem>
                                ) : (
                                    unitData.map((data) => {
                                        return (
                                            <MenuItem key={data.id} value={data.id} name={data.name}>
                                                {data.name}
                                            </MenuItem>
                                        );
                                    })
                                )}
                            </Select>
                        </FormControl>

                        <Box textAlign="center" sx={{ backgroundColor: 'white' }}>
                            <Button
                                variant="contained"
                                centerRipple
                                onClick={handleClickSelectButton}
                                disabled={!selectedUnit || isLoading}
                                size="large"
                                endIcon={!isLoading && <ArrowForwardIcon />}
                                sx={{ minWidth: 140 }}
                            >
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Continue'}
                            </Button>
                        </Box>
                    </>
                )}
            </Box>
            <AlertBar open={openmessageflag} message={errorMessage} severity="error" closeHandler={handleMessageClose}></AlertBar>
        </div>
    );
};

export default withAuthenticationRequired(UnitSelection, {
    onRedirecting: () => <ReactLoading type="Spin" color="#fff" />
});
